import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import DataTable from "react-data-table-component";

const CustQualityInspectionModal = React.forwardRef(
  ({ show, onHide, inspectionType, rowData, grnData, onSubmit, ...props }, ref) => {

    const showPhysicalVerification = inspectionType === "physical";
    const showSpecificationCheck = inspectionType === "specification";
    const showQualityCheck = inspectionType === "qualityCheck";
    const [physicalData, setPhysicalData] = useState({
      packagingCondition: "",
      physicalDamage: "",
      quantityVerified: "",
      inspectionRemarks: "",
      module: "SUPPLIER",
      transactionType: "QTYINP",
    });

    const [specificationData, setSpecificationData] = useState({
      modelMatchesPo: "",
      brandMatchesPo: "",
      sizeGradeMatch: "",
      technicalParametersOk: "",
      module: "SUPPLIER",
      transactionType: "QTYINP",
    });

    const defaultQualityCheckData = [
      {
        checkpointTitle: "Packing method",
        checkpointCategory: "Export Packing",
        checkpointMotive: "Conformance to Specs",
        samplingSize: "1 pc",
        numberOfSamples: "",
        description: "Report quantity and breakdown inside export cartons.",
        requiredResult: "Compare to client specification if applicable.",
        result: "",
      },
      {
        checkpointTitle: "Shipping marks",
        checkpointCategory: "Export Packing",
        checkpointMotive: "Conformance to Specs",
        samplingSize: "1 pc",
        numberOfSamples: "",
        description: "Report actual shipping marks on export cartons",
        requiredResult: "Compare to client specification if applicable.",
        result: "",
      },
      {
        checkpointTitle: "Gross weight",
        checkpointCategory: "Export Packing",
        checkpointMotive: "Conformance to Specs",
        samplingSize: "1 pc",
        numberOfSamples: "",
        description: "Take weight, report actual finding. Values in kg.",
        requiredResult:
          "Compare to client specifications and perfect sample if applicable.",
        result: "",
      },
      {
        checkpointTitle: "Dimensions",
        checkpointCategory: "Export Packing",
        checkpointMotive: "Conformance to Specs",
        samplingSize: "1 pc",
        numberOfSamples: "",
        description: "Take dimensions, report actual finding. Values in cm.",
        requiredResult:
          "Compare to client specifications and perfect sample if applicable.",
        result: "",
      },
      {
        checkpointTitle: "Barcode scan",
        checkpointCategory: "Export Packing",
        checkpointMotive: "Conformance to Specs",
        samplingSize: "Custom",
        numberOfSamples: "5",
        description: "Scan barcode",
        requiredResult:
          "Compare result with actual printed number and specification from client if applicable.",
        result: "",
      },
      {
        checkpointTitle: "Carton details",
        checkpointCategory: "Export Packing",
        checkpointMotive: "Conformance to Specs",
        samplingSize: "All samples",
        numberOfSamples: "",
        description: "Look at carton details.",
        requiredResult:
          "Report actual findings and tick the boxes below. Findings must conform to client specifications.",
        result: "",
      },
      {
        checkpointTitle: "Free-fall carton drop test",
        checkpointCategory: "Export Packing",
        checkpointMotive: "Function, Endurance, Usability",
        samplingSize: "1 pc",
        numberOfSamples: "",
        description:
          "Drop carton 10 times (1 corner / 3 edges / 6 sides) on concrete floor.",
        requiredResult:
          "Carton should not be seriously damaged. Products should still function normally.",
        result: "",
      },
      {
        checkpointTitle: "Inner packing contents",
        checkpointCategory: "Inner Packing",
        checkpointMotive: "Conformance to Specs",
        samplingSize: "All samples",
        numberOfSamples: "",
        description: "Check quantity and breakdown inside inner packing",
        requiredResult: "Compare to client specification if applicable.",
        result: "",
      },
      {
        checkpointTitle: "Inner packing marks",
        checkpointCategory: "Inner Packing",
        checkpointMotive: "Conformance to Specs",
        samplingSize: "All samples",
        numberOfSamples: "",
        description: "Report actual shipping marks on inner cartons",
        requiredResult: "Compare to client specification if applicable.",
        result: "",
      },
      {
        checkpointTitle: "Inner packing gross weight",
        checkpointCategory: "Inner Packing",
        checkpointMotive: "Conformance to Specs",
        samplingSize: "Custom",
        numberOfSamples: "2",
        description: "Take weight, report actual finding. Values in kg.",
        requiredResult:
          "Compare to client specifications and perfect sample if applicable.",
        result: "",
      },
    ];

    const [qualityCheckTableData, setQualityCheckTableData] = useState(
      defaultQualityCheckData
    );

    const handlePhysicalChange = (e) => {
      setPhysicalData({ ...physicalData, [e.target.name]: e.target.value });
    };

    const handleSpecificationChange = (e) => {
      setSpecificationData({
        ...specificationData,
        [e.target.name]: e.target.value,
      });
    };

    const handleResultChange = (index, value) => {
      const updatedData = [...qualityCheckTableData];
      updatedData[index].result = value;
      setQualityCheckTableData(updatedData);
    };

    const resetQualityCheckData = () => {
      setQualityCheckTableData(
        defaultQualityCheckData.map((item) => ({ ...item, result: "" }))
      );
    };

  const handleSubmit = () => {
  // 1. Build inspection entry
  let inspectionEntry = {};

  if (inspectionType === "physical") {
    inspectionEntry = {
      type: "physical",
      ...physicalData,
    };
  } else if (inspectionType === "specification") {
    inspectionEntry = {
      type: "specification",
      ...specificationData,
    };
  } else if (inspectionType === "qualityCheck") {
    inspectionEntry = {
      type: "qualityCheck",
      checkpoints: qualityCheckTableData,
      module: "SUPPLIER",
      transactionType: "QTYINP",
    };
  }
  const updatedItems = grnData.items.map((item) => {
    if (item.grnItemNr === rowData?.grnItemNr) {
      const existing = item.qualityInspection || [];
      return {
        ...item,
        qualityInspection: [...existing, inspectionEntry],
      };
    }
    return item;
  });

  const updatedGrnData = {
    ...grnData,
    items: updatedItems, 
  };
  

  console.log("Updated GRN:", JSON.stringify(updatedGrnData, null, 2));

  if (onSubmit) onSubmit(updatedGrnData);
  onHide();
};
    const InfoTable = () => (
      <div
        style={{
          border: "1px solid #d6d6d6",
          borderRadius: "8px",
          overflow: "hidden",
          marginBottom: "20px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            <tr>
              <td
                style={{
                  padding: "14px",
                  borderRight: "1px solid #d6d6d6",
                  whiteSpace: "nowrap",
                  fontWeight: "600",
                  verticalAlign: "top",
                }}
              >
                GRN Item : {rowData?.grnItemNr || "--"}
              </td>
              <td
                style={{
                  padding: "14px",
                  borderRight: "1px solid #d6d6d6",
                  whiteSpace: "nowrap",
                  fontWeight: "600",
                  verticalAlign: "top",
                }}
              >
                Material Code : {rowData?.materialCode || "--"}
              </td>
              <td
                style={{
                  padding: "14px",
                  borderRight: "1px solid #d6d6d6",
                  width: "50%",
                  verticalAlign: "top",
                }}
              >
                <div style={{ fontWeight: "600", marginBottom: "4px" }}>
                  Material :
                </div>
                <div
                  style={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: "1.5",
                  }}
                >
                  {rowData?.materialDescription || "--"}
                </div>
              </td>
              <td
                style={{
                  padding: "14px",
                  whiteSpace: "nowrap",
                  fontWeight: "600",
                  verticalAlign: "top",
                }}
              >
                Quantity : {rowData?.grnQuantity || "--"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );

    const ModalFooterButtons = ({ onCancel }) => (
      <Modal.Footer>
        <button onClick={handleSubmit} className="btn btn-primary">
          Submit
        </button>
        <button onClick={onCancel} className="btn btn-danger">
          Cancel
        </button>
      </Modal.Footer>
    );
    const qualityColumns = [
      {
        name: "Checkpoint Title",
        selector: (row) => row.checkpointTitle,
        wrap: true,
        width: "180px",
      },
      {
        name: "Checkpoint Category",
        selector: (row) => row.checkpointCategory,
        wrap: true,
        width: "180px",
      },
      {
        name: "Checkpoint Motive",
        selector: (row) => row.checkpointMotive,
        wrap: true,
        width: "180px",
      },
      {
        name: "Sampling Size",
        selector: (row) => row.samplingSize,
        width: "120px",
      },
      {
        name: "No. of Samples",
        selector: (row) => row.numberOfSamples,
        width: "130px",
      },
      {
        name: "Description",
        selector: (row) => row.description,
        wrap: true,
        width: "280px",
      },
      {
        name: "Required Result",
        selector: (row) => row.requiredResult,
        wrap: true,
        width: "280px",
      },
      {
        name: "Result",
        cell: (row, index) => (
          <TextAreaField
            className="form-control"
            rows={3}
            placeholder="Enter Result"
            value={row.result || ""}
            onChange={(e) => handleResultChange(index, e.target.value)}
            style={{ minWidth: "220px", fontSize: "12px" }}
          />
        ),
        width: "260px",
      },
    ];
    return (
      <>
        {/* ======= PHYSICAL VERIFICATION ======= */}
        <Modal
          show={show && showPhysicalVerification}
          onHide={onHide}
          keyboard={false}
          size="xl"
          centered
          ref={ref}
          {...props}
        >
          <Modal.Header closeButton style={{ background: "#80aee6" }}>
            <Modal.Title>Physical Verification</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <InfoTable />
            <Row className="mb-4">
              <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label={
                    <>
                      <i className="bi bi-box-seam labelIcon"></i>
                      Packaging Condition
                    </>
                  }
                  name="packagingCondition"
                  id="packagingCondition"
                  value={physicalData.packagingCondition}
                  onChange={handlePhysicalChange}
                />
              </Col>
              <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label={
                    <>
                      <i className="bi bi-exclamation-triangle labelIcon"></i>
                      Physical Damage
                    </>
                  }
                  name="physicalDamage"
                  id="physicalDamage"
                  value={physicalData.physicalDamage}
                  onChange={handlePhysicalChange}
                />
              </Col>
              <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label={
                    <>
                      <i className="bi bi-check-circle labelIcon"></i>
                      Quantity Verified
                    </>
                  }
                  name="quantityVerified"
                  id="quantityVerified"
                  value={physicalData.quantityVerified}
                  onChange={handlePhysicalChange}
                />
              </Col>
              <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label={
                    <>
                      <i className="bi bi-chat-left-text labelIcon"></i>
                      Inspection Remarks
                    </>
                  }
                  name="inspectionRemarks"
                  id="inspectionRemarks"
                  value={physicalData.inspectionRemarks}
                  onChange={handlePhysicalChange}
                />
              </Col>
            </Row>
          </Modal.Body>

          <ModalFooterButtons onCancel={onHide} />
        </Modal>

        {/* ======= SPECIFICATION CHECK ======= */}
        <Modal
          show={show && showSpecificationCheck}
          onHide={onHide}
          keyboard={false}
          size="xl"
          centered
        >
          <Modal.Header closeButton style={{ background: "#80aee6" }}>
            <Modal.Title>Specification Check</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <InfoTable />
            <Row className="mb-4">
              <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label={
                    <>
                      <i className="bi bi-check2-square labelIcon"></i>
                      Model Matches PO
                    </>
                  }
                  name="modelMatchesPo"
                  id="modelMatchesPo"
                  value={specificationData.modelMatchesPo}
                  onChange={handleSpecificationChange}
                />
              </Col>
              <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label={
                    <>
                      <i className="bi bi-tags labelIcon"></i>
                      Brand Matches PO
                    </>
                  }
                  name="brandMatchesPo"
                  id="brandMatchesPo"
                  value={specificationData.brandMatchesPo}
                  onChange={handleSpecificationChange}
                />
              </Col>
              <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label={
                    <>
                      <i className="bi bi-rulers labelIcon"></i>
                      Size / Grade Match
                    </>
                  }
                  name="sizeGradeMatch"
                  id="sizeGradeMatch"
                  value={specificationData.sizeGradeMatch}
                  onChange={handleSpecificationChange}
                />
              </Col>
              <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label={
                    <>
                      <i className="bi bi-tools labelIcon"></i>
                      Technical Parameters OK
                    </>
                  }
                  name="technicalParametersOk"
                  id="technicalParametersOk"
                  value={specificationData.technicalParametersOk}
                  onChange={handleSpecificationChange}
                />
              </Col>
            </Row>
          </Modal.Body>

          <ModalFooterButtons onCancel={onHide} />
        </Modal>

        {/* ======= QUALITY CHECK ======= */}
        <Modal
          show={show && showQualityCheck}
          onHide={onHide}
          keyboard={false}
          size="xl"
          centered
        >
          <Modal.Header closeButton style={{ background: "#80aee6" }}>
            <Modal.Title>Quality Check</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <InfoTable />
            <Row className="accordion-body">
              <Col xs={12} md={12} lg={12}>
                <DataTable
                  columns={qualityColumns}
                  data={qualityCheckTableData}
                  pagination
                  highlightOnHover
                  responsive
                  dense
                  fixedHeader
                  fixedHeaderScrollHeight="500px"
                />
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <button onClick={handleSubmit} className="btn btn-primary">
              Submit
            </button>
            <button
              onClick={() => {
                resetQualityCheckData();
                onHide();
              }}
              className="btn btn-danger"
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
);

export default CustQualityInspectionModal;